export default "__VITE_ASSET__Bq_oFL7l__"